import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/Index/index'

import upmarket from '@/view/upmarket' //上市公司筛选

//登录部分
import Login from '@/view/login/login' //登录公告
import Storeup from '@/view/login/storeup' //收藏页面
import Map from '@/view/login/map'
import Map2 from '@/view/login/map2'
import Test from '@/view/login/test'

//产业地图部分
import IndustryMap from '@/view/industryMap/index'
import Migrationmap from '@/view/migrationMap/index' //迁徙地图部分
import Developmap from '@/view/developMap/index' //发展概况部分


import Stock from '@/view/stock'
import Structure from '@/view/stock/structure'
import Major from '@/view/stock/major'
import Circulate from '@/view/stock/circulate'
import Fund from '@/view/stock/fund'
import Executive from '@/view/stock/executive'
import Inside from '@/view/stock/inside'
import Sell from '@/view/stock/sell'
import Collect from '@/view/collect'
//公司基础信息部分
import BaseInfo from '@/view/companyBaseInfo/index' //公司简介
import InComing from '@/view/companyBaseInfo/incoming' //收入构成
import Management from '@/view/companyBaseInfo/management' //高层管理
import Employee from '@/view/companyBaseInfo/employee' //员工构成
import Personinfo from '@/view/companyBaseInfo/personinfo' //个人简介

//发行分配部分
import Getpay from '@/view/distribution/getpay' //分红情况
import Addmore from '@/view/distribution/addmore' //增发
import Newmarket from '@/view/distribution/newmarket' //新股发行
import Sharemarket from '@/view/distribution/sharemarket' //配股情况
import Marketplan from '@/view/distribution/plan' //历年融资计划

//财务数据部分
import Financeinfo from '@/view/finance/financeinfo' //财务摘要表
import Liabilities from '@/view/finance/liabilities' //资产负债表
import Cashcount from '@/view/finance/cashcount' //现金流量表
import Profit from '@/view/finance/profit' //利润表
import Marketrights from '@/view/finance/marketrights' //股东权益增减
import Forecastpredict from '@/view/finance/forecastpredict' //股东权益增减

//资本运作部分
import Participant from '@/view/capital/participant' //参股券商
import Controllers from '@/view/capital/controllers' //控股参股
import Exchange from '@/view/capital/exchange' //资产置换
import Transactions from '@/view/capital/transactions' //资产交易
import Divestiture from '@/view/capital/divestiture' //资产剥离

//重大事项部分
import Pledge from '@/view/majorevents/pledge' //股权质押
import Reorganization from '@/view/majorevents/reorganization' //并购重组
import Reorganizationdetail from '@/view/majorevents/reorganizationdetail' //并购重组__详情页
import Meetingnotice from '@/view/majorevents/meetingnotice' //股东大会通知
import Violation from '@/view/majorevents/violation' //违规记录
import Arbitration from '@/view/majorevents/arbitration' //诉讼仲裁
import Guarantee from '@/view/majorevents/guarantee' //对外担保

//公告部分
import Announcement from '@/view/notice/announcement' //公司公告
import Cinformation from '@/view/notice/cinformation' //公司资讯
import Hinformation from '@/view/notice/hinformation' //行业资讯

// 财务分析部分
import Norm from '@/view/analyze/norm'
import Gain from "@/view/analyze/gain"
import Repay from '@/view/analyze/repay'
import Growth from '@/view/analyze/growth'
import Operate from '@/view/analyze/operate'
import Dupont from '@/view/analyze/dupont'
import Palepu from '@/view/analyze/palepu'
import Zscore from '@/view/analyze/zscore'
import Fscore from '@/view/analyze/fscore'
import Bazhory from '@/view/analyze/Bazhory'

// 医药公司-----库---筛选
import Pharma from '@/view/pharma'
import TradingSum from '@/view/pharma/tradingSum' //进出口金额
import TradingAmount from '@/view/pharma/tradingAmount' //进出口数量
import ChemicalMajor from '@/view/pharma/chemicalMajor' //主要品种产量
import Midbody from '@/view/pharma/midbody' //中间体品种产量
import TwentyFour from '@/view/pharma/twentyFour' //二十四大类品种产量、出口量
import NewDrugs from '@/view/pharma/newDrugs' //批准新药
import ChineseMedicine from '@/view/pharma/ChineseMedicine' //中药生物制药主要品种产量
import Instrument from '@/view/pharma/instrument' //医药器械主要品种产量
import Thirdly from '@/view/pharma/thirdly' //CFDA批准的境内第三医疗器械
import Emphasis from '@/view/pharma/emphasis' //主要城市重点医院用药品种金额排序
import DrugForm from '@/view/pharma/DrugForm' //医药企业名录
import Standard from '@/view/pharma/standard' //通过《药品生产质量管理规范》认证的企业
import International from '@/view/pharma/international' //通过制剂国际认证的企业

// 医药公司--搜索
import Medicine from '@/view/medicine'


import Customs from '@/view/customs' // 海关
import CustomsRight from '@/view/customs/rightPage.vue'; // 海关右侧页面
import Industrial from '@/view/industrial' //工业
import industrialRight from '@/view/industrial/rightPage.vue'; // 工业右侧页面

import Enterprises from '@/view/enterprises/index.vue' //上市企业
import entDefault from '@/view/enterprises/default'; // 上市企业默认

import Tendering from '@/view/tendering/index.vue' //政府采购
import Tedefault from '@/view/tendering/default.vue' //政府采购
import zDetail from '@/view/tendering/detail.vue' //政府采购

import Judgement from '@/view/judgement/index.vue' //裁判文书
import Judefault from '@/view/judgement/default.vue' //裁判文书
import Detail from '@/view/judgement/detail.vue' //裁判文书


import enterprisesDetail from '@/view/enterprises/enterprisesDetail.vue' //企业画像
import enterprisesDetail2 from '@/view/enterprises/enterprisesDetail2.vue' //企业画像

import atlas from '@/view/enterprises/atlas.vue';
import SearchPage from '@/view/searchPage/index.vue' //检索结果

import Platform from '@/view/platform/index.vue' //开放平台

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            redirect: '/index'
        },

        { //首页
            path: '/index',
            component: Index
        },
        { //登录页
            path: '/login',
            component: Login
        },
        { //地图下钻测试组件
            path: '/map',
            component: Map
        },
        { //地图下钻测试组件
            path: '/map2',
            component: Map2
        },
        { //收藏页
            path: '/storeup',
            component: Storeup
        },
        { //上市信息库--筛选
            path: '/upmarket',
            component: upmarket
        },
        { //医药公司------库---筛选
            path: '/pharma',
            name: 'pharma',
            component: Pharma,
            redirect: { name: 'chemicalMajor' },
            children: [{ //进出口金额
                    path: 'tradingSum',
                    name: 'tradingSum',
                    component: TradingSum
                },
                { //进出口数量
                    path: 'tradingAmount',
                    name: 'tradingAmount',
                    component: TradingAmount
                },
                // 化学制剂
                { //主要品种产量
                    path: 'chemicalMajor',
                    name: 'chemicalMajor',
                    component: ChemicalMajor
                },
                { //中间体品种产量
                    path: 'midbody',
                    name: 'midbody',
                    component: Midbody
                },
                { //二十四大类品种产量、出口量
                    path: 'twentyFour',
                    name: 'twentyFour',
                    component: TwentyFour
                },
                { //批准新药
                    path: 'newDrugs',
                    name: 'newDrugs',
                    component: NewDrugs
                },
                { //中药生物制药主要品种产量
                    path: 'ChineseMedicine',
                    name: 'ChineseMedicine',
                    component: ChineseMedicine
                },
                { //医药器械主要品种产量
                    path: 'instrument',
                    name: 'instrument',
                    component: Instrument
                },
                { //CFDA批准的境内第三医疗器械
                    path: 'thirdly',
                    name: 'thirdly',
                    component: Thirdly
                },
                { //主要城市重点医院用药品种金额排序
                    path: 'emphasis',
                    name: 'emphasis',
                    component: Emphasis
                },
                { //医药企业名录
                    path: 'DrugForm',
                    name: 'DrugForm',
                    component: DrugForm
                },
                { //通过《药品生产质量管理规范》认证的企业
                    path: 'standard',
                    name: 'standard',
                    component: Standard
                },
                { //通过制剂国际认证的企业
                    path: 'international',
                    name: 'international',
                    component: International
                }, { //医药公司--搜索
                    path: '/medicine',
                    name: 'medicine',
                    component: Medicine,
                },
            ]
        },
        {
            path: '/customs', //海关
            name: 'customs',
            component: Customs,
            redirect: { name: 'CustomsRight' },
            children: [{
                path: 'CustomsRight',
                name: 'CustomsRight',
                component: CustomsRight
            }]
        },
        {
            path: '/industrial', //工业
            name: 'industrial',
            component: Industrial,
            redirect: { name: 'industrialRight' },
            children: [{
                path: 'industrialRight',
                name: 'industrialRight',
                component: industrialRight
            }]

        },
        { //医药企业名录
            path: 'DrugForm',
            name: 'DrugForm',
            component: DrugForm
        },
        { //通过《药品生产质量管理规范》认证的企业
            path: 'standard',
            name: 'standard',
            component: Standard
        },
        { //通过制剂国际认证的企业
            path: 'international',
            name: 'international',
            component: International
        },
        { //产业地图部分
            path: '/industrymap',
            component: IndustryMap
        },
        { //迁徙地图部分
            path: '/migrationmap',
            component: Migrationmap
        },
        { //发展概况部分
            path: '/developmap',
            component: Developmap
        },
        //专题数据
        {
            path: '/enterprises', //上市企业
            name: 'enterprises',
            component: Enterprises,
            redirect: { name: 'entDefault' },
            children: [{
                path: 'entDefault',
                name: 'entDefault',
                component: entDefault
            }]
        },
        {
            path: '/tendering', //政府采购
            name: 'tendering',
            component: Tendering,
            redirect: { name: 'tedefault' },
            children: [{
                path: 'tedefault',
                name: 'tedefault',
                component: Tedefault
            }]
        },
        {
            path: '/tenderdetail',
            name: 'tenderdetail',
            component: zDetail
        },
        {
            path: '/judgement', //裁判文书
            name: 'judgement',
            component: Judgement,
            redirect: { name: 'judefault' },
            children: [{
                path: 'judefault',
                name: 'judefault',
                component: Judefault
            }]
        },
        {
            path: '/detail',
            name: 'detail',
            component: Detail
        },

        {
            path: '/enterprisesDetail', //企业画像
            name: 'enterprisesDetail',
            component: enterprisesDetail
        },
        {
            path: '/enterprisesDetail2', //企业画像2
            name: 'enterprisesDetail2',
            component: enterprisesDetail2
        },
        {
            path: '/atlas', //企业图谱
            name: 'atlas',
            component: atlas
        },
        {
            path: '/searchPage', //检索结果页面
            name: 'searchPage',
            component: SearchPage
        },
        {
            path: '/platform', //开放平台
            name: 'platform',
            component: Platform
        },
        { //个人简介
            path: '/personinfo',
            component: Personinfo
        },
        {
            // path: '/stock/:stockId',
            path: '/stock/:dbcode',
            name: 'stock',
            component: Stock,
            redirect: { name: 'baseinfo' },
            children: [
                //股本股东
                {
                    path: 'structure',
                    name: 'structure',
                    component: Structure
                },
                {
                    path: 'major',
                    name: 'major',
                    component: Major
                },
                {
                    path: 'circulate',
                    name: 'circulate',
                    component: Circulate
                },
                {
                    path: 'fund',
                    name: 'fund',
                    component: Fund
                },
                {
                    path: 'executive',
                    name: 'executive',
                    component: Executive
                },
                {
                    path: 'inside',
                    name: 'inside',
                    component: Inside
                },
                {
                    path: 'sell',
                    name: 'sell',
                    component: Sell
                },
                //公司基础信息
                {
                    path: 'baseinfo',
                    name: 'baseinfo',
                    component: BaseInfo
                },
                { //高层管理
                    path: 'management',
                    name: 'management',
                    component: Management
                },
                { //收入构成
                    path: 'incoming',
                    name: 'incoming',
                    component: InComing
                },
                { //员工构成
                    path: 'employee',
                    name: 'employee',
                    component: Employee
                },
                //发行分配部分
                { //分红情况
                    path: 'getpay',
                    name: 'getpay',
                    component: Getpay
                },
                { //增发
                    path: 'addmore',
                    name: 'addmore',
                    component: Addmore
                },
                { //新股发行
                    path: 'newmarket',
                    name: 'newmarket',
                    component: Newmarket
                },
                { //配股情况
                    path: 'sharemarket',
                    name: 'sharemarket',
                    component: Sharemarket
                },
                { //历年融资计划
                    path: 'marketplan',
                    name: 'marketplan',
                    component: Marketplan
                },
                //财务数据部分
                { //历年融资计划Financeinfo
                    path: 'financeinfo',
                    name: 'financeinfo',
                    component: Financeinfo
                },
                { //资产负债表
                    path: 'liabilities',
                    name: 'liabilities',
                    component: Liabilities
                },
                { //资产负债表
                    path: 'cashcount',
                    name: 'cashcount',
                    component: Cashcount
                },
                { //利润表
                    path: 'profit',
                    name: 'profit',
                    component: Profit
                },
                { //股东权益增减
                    path: 'marketrights',
                    name: 'marketrights',
                    component: Marketrights
                },
                { //业绩预告
                    path: 'forecastpredict',
                    name: 'forecastpredict',
                    component: Forecastpredict
                },
                // 财务分析
                {
                    path: 'norm',
                    name: 'norm',
                    component: Norm
                },
                //资本运作部分 
                //参股券商
                {
                    path: 'participant',
                    name: 'participant',
                    component: Participant
                },
                //控股参股
                {
                    path: 'controllers',
                    name: 'controllers',
                    component: Controllers
                },
                //资产置换
                {
                    path: 'exchange',
                    name: 'exchange',
                    component: Exchange
                },
                //资产交易
                {
                    path: 'transactions',
                    name: 'transactions',
                    component: Transactions
                },
                //资产剥离
                {
                    path: 'divestiture',
                    name: 'divestiture',
                    component: Divestiture
                },
                { //盈利能力
                    path: 'gain',
                    name: 'gain',
                    component: Gain
                },
                { //偿还能力
                    path: 'repay',
                    name: 'repay',
                    component: Repay
                },
                { //成长能力
                    path: 'growth',
                    name: 'growth',
                    component: Growth
                },
                { //营运能力
                    path: 'operate',
                    name: 'operate',
                    component: Operate
                },
                { //杜邦分析
                    path: 'dupont',
                    name: 'dupont',
                    component: Dupont
                },
                { //帕利普分析
                    path: 'palepu',
                    name: 'palepu',
                    component: Palepu
                },
                { //Z-分数
                    path: 'zscore',
                    name: 'zscore',
                    component: Zscore
                },
                { //F-分数
                    path: 'fscore',
                    name: 'fscore',
                    component: Fscore
                },
                { //巴萨利分数
                    path: 'Bazhory',
                    name: 'Bazhory',
                    component: Bazhory
                },
                //重大事项部分
                { //股权质押
                    path: 'pledge',
                    name: 'pledge',
                    component: Pledge
                },
                { //股权质押
                    path: 'reorganization',
                    name: 'reorganization',
                    component: Reorganization
                },
                { //股东大会通知
                    path: 'meetingnotice',
                    name: 'meetingnotice',
                    component: Meetingnotice
                },
                { //违规记录
                    path: 'violation',
                    name: 'violation',
                    component: Violation
                },
                { //诉讼仲裁
                    path: 'arbitration',
                    name: 'arbitration',
                    component: Arbitration
                },
                { //对外担保
                    path: 'guarantee',
                    name: 'guarantee',
                    component: Guarantee
                },
                //公告部分
                { //公司公告
                    path: 'announcement',
                    name: 'announcement',
                    component: Announcement
                },
                { //公司资讯
                    path: 'cinformation',
                    name: 'cinformation',
                    component: Cinformation
                },
                { //行业资讯
                    path: 'hinformation',
                    name: 'hinformation',
                    component: Hinformation
                },
            ]
        },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js